import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { CountryView, SearchCountryParameters } from '@api-proxies';
import { CountryService } from '@services/http/clients/country.service';
import { GenericTypeAheadDropdownComponent } from 'ngx-lib';
import { FormEditorBase, createValueAccessorProvider } from '../base/form-editor-base';

@Component({
    selector: 'app-country-form-editor',
    templateUrl: './country-form-editor.component.html',
    styleUrls: ['./country-form-editor.component.scss'],
    providers: [createValueAccessorProvider(CountryFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericTypeAheadDropdownComponent]
})
export class CountryFormEditorComponent extends FormEditorBase<CountryView[]> implements OnInit {
    value = input<CountryView[]>();
    readonly = input<boolean>(false);
    placeholderText = input<string>('Select Country');
    labelText = input<string>('Country');

    private readonly countryService = inject(CountryService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.items.set([]);
    }

    selectedItem(): CountryView | undefined {
        const items = this.selectedItems();
        return items && items.length > 0 ? items[0] : undefined;
    }

    onSelectedItemChange(item?: CountryView): void {
        if (item) {
            this.onSelectedItemsChange([item]);
        } else {
            this.onSelectedItemsChange([]);
        }
    }

    protected override async onEntityTextChange(text: string): Promise<void> {
        if (!text) {
            this.items.set([]);
            return;
        }

        const countries = await this.countryService.search({
            filterText: text
        } as SearchCountryParameters);

        this.items.set(countries);
    }

    protected override mapSelectedItemsToValue(): CountryView[] {
        return this.selectedItems() || [];
    }

    protected override mapValueToSelectedItems(value: CountryView[]): any[] {
        return value || [];
    }
}
